import { all, put, call, takeEvery, takeLatest } from "redux-saga/effects";
import api_service from "../../network/api_callbacks";
import {
    GET_CATEGORIES_REQUEST,
    getCategoriesSuccess,
    getCategoriesFailure
} from "../actions/getCategories"

function* getCategoriesSaga(action) {
    try {
        const response = yield call(api_service.getCategories, action.payload);
        console.log("response : ",response)
        if(response?.code === 'ERR_NETWORK')
        {
            console.log(response);
            yield put(getCategoriesFailure(response?.message || 'failed'));    
        }
        else {
        yield put(getCategoriesSuccess(response));
        }
    } catch (err) {
        console.log(err);
        yield put(getCategoriesFailure(err.response?.data?.message || 'failed'));
    }
}

export default function* watchGetCategoriesSaga() {
    yield takeEvery(GET_CATEGORIES_REQUEST, getCategoriesSaga);
}
